<template lang="html">
  <v-app class="large-screen__body white">
    <div class="outer-div">
      <v-toolbar dark tabs>
        <v-spacer></v-spacer>
        <v-toolbar-title class="white--text center">
          Effort
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom left style="z-index: 40;">
          <v-btn icon slot="activator" dark>
            <img src="~icons/moreIcon/moreIcon.png" alt="moreIcon">
          </v-btn>
          <v-list>
            <v-list-tile :to="{name: 'Tasks', query: { browse_id: 1 }}">
              <v-list-tile-title>Find Effort</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-tabs grow fixed-tabs centered slot="extension" class="primary-tabs">
          <v-tab :to="{name: 'Tasks'}">
            Browse
          </v-tab>
          <v-tab :to="{name: 'TasksFollowing'}">
            Following
          </v-tab>
          <v-tab :to="{name: 'TasksRegistered'}">
            Registered
          </v-tab>
        </v-tabs>
      </v-toolbar>

      <div id="show" class="body">
        <router-view></router-view>
      </div>
    </div>
  </v-app>
</template>


<script>
export default {
  methods: {
    navigateToTaskDetails(taskId) {
      this.$router.push({ name: 'TaskDetails', params: { id: taskId } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

#app {
  .outer-div {
    height: 100%;
  }

  .body {
    padding-top: 20px;
    padding-left: 10px;
    padding-right: 10px;

    span {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/EffortLayout.vue